import { render, staticRenderFns } from "./zhenxuangu.vue?vue&type=template&id=790ca546&scoped=true"
import script from "./zhenxuangu.vue?vue&type=script&lang=js"
export * from "./zhenxuangu.vue?vue&type=script&lang=js"
import style0 from "./zhenxuangu.vue?vue&type=style&index=0&id=790ca546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ca546",
  null
  
)

export default component.exports